import React, {Component, useState, useRef, useEffect} from 'react';
import styled from 'styled-components';
import QBELogo from '../../assets/QBE_logo.svg';
import GNMLogo from '../../assets/GnM_logo.png';
import BMLogo from '../../assets/BmLogo.png';
import ContactUsIcon from '../../assets/ContactUs.png';
import {withRouter} from "react-router-dom";
import { _gaPushData, _gaPushEvent } from '../../utils/utility';
import {mdDownN} from "../../ui/common";
import LandingImgBm from "../../assets/LandingImgBm.jpg";
import LandingImg from "../../assets/Landing_img.jpg";
import LandingImgMLA from "../../assets/MLA_logo.png";
import MLALogo from "../../assets/MLA_logo.png";

const LandingHeaderStyle = styled.div`
    display: flex;
    flex-wrap: wrap;
    position: fixed;
    height: 60px;
    width: 1440px;
    background-color: #14284B;
    z-index: 100;
    @media (max-width: 1400px){
        width: 100vw;
    }
    ${mdDownN`
        width: 100vw;
        height: unset;
        flex-direction: column;
        justify-content: center;
        // position:fixed;
    `}
`;

const LandingLogoGroup1Style = styled.div`
    display: flex;
    position: absolute;
    left: 152px;
    height: 60px;
    width: 333px;
    ${mdDownN`
        left:auto;
        position:relative;
        width:160px;
        margin: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
    `}
`;

const LandingLogoGroup2Style = styled.div`
    display: flex;
    position: absolute;
    top: 17px;
    height: 27px;
    width: 160px;
    ${mdDownN`
        margin:auto;
    `}
`;

const LandingGnmLogoStyle = styled.img`
    display: inline-block;
    position: absolute;
    top: 1px;
    height: 26px;
    width: 54px;
    &:hover{
        cursor: pointer;
    }
`;
const LandingMLALogoStyle = styled.img`
    display: inline-block;
    position: absolute;
    top: 2px;
    height: 26px;
    width: auto;
    &:hover{
        cursor: pointer;
    }
`;

const LandingBmLogoStyle = styled.img`
    display: inline-block;
    position: absolute;
    top: -10px;
    height: 46px;
    width: 54px;
`;

const LandingPathStyle = styled.div`
    display: inline-block;
    position: absolute;
    ${({left})=>left?left:'left: 67px;'}
    box-sizing: border-box;
    height: 26.73px;
    width: 1px;
    border: 1px solid #FFFFFF;
    opacity: 0.48;
`;

const LandingQbeLogoStyle = styled.div`
    display: inline-block;
    position: absolute;
    top: 2px;
    ${({left})=>left?left:'left: 82px;'}
    height: 22px;
    width: 78px;
    background-image: url(${QBELogo}); 
    &:hover{
        cursor: pointer;
    }
`;

const LandingContactUsGroupStyle = styled.div`
    position: absolute;
    top: 0px;
    left: 1196px;
    height: 60px;
    width: 200px;
    margin: 0;
    @media (max-width: 1400px){
        left: auto;
        width: 150px;
        right: 0;
    }
    ${mdDownN`
        display: none;
    `}
`;

const LandingContactUsStyle = styled.div`
    position: absolute;
    top: 20px;
    height: auto;
    width: auto;
    margin: 0;
    font-family: "Inter-Medium", Helvetica, Arial, serif;
    font-size: 14.0px;
    color: rgba(255, 255, 255, 1.0);
    text-align: left;
    line-height: 20.0px;
`;

const LandingContactUsIconGroupStyle = styled.div`
    top: 0px;
    height: 60px;
    width: 60px;
    position: absolute;
    margin: 0;
    left: 104px;
    overflow: hidden;
    ${mdDownN`
        position: relative;
        left:0px
    `}
`;

const LandingContactUsIconStyle = styled.img`
    top: 18px;
    height: 24px;
    width: 24px;
    position: absolute;
    margin: 0;
    left: 18px;
    overflow: hidden;
    ${mdDownN`
        filter: invert(100%);
        height: 22px;
        width: 22px;
    `}
`;

const LandingContactUsUnderlineStyle = styled.div`
    display: flex;
    position: fixed;
    top: 57px;
    height: 3px;
    width: 73px;
    background-color: #009AE4;
    z-index: 5;
`;

const LandingContactUsPopupStyle = styled.div`
    display: flex;
    position: fixed;
    z-index: 1;
    overflow: auto;
    top: 61px;
    height: 158px;
    height: 188px;
    width: 232px;
    margin: 0 0 0 -147px;
    z-index: 1;
`;

const LandingContactUsPopupBorderStyle = styled.div`
    position: absolute;
    height: 146px;
    height: 164px;
    &.mla{
        height: 175px;    
    }
    // height: 176px;
    width: 220px;
    background-color: #FFFFFF;
    box-shadow: 4px 4px 12px 0 rgba(20,40,75,0.2);
    z-index: 2;
`;

const LandingContactUsPopupYourAgentStyle = styled.div`
    position: absolute;
    top: 30px;
    left: 24px;
    height: 18px;
    width: 155px;
    color: #003DA5;
    font-family: Inter-Regular;
    font-size: 14px;
    line-height: 18px;
    z-index: 3;
    ${mdDownN`
        width: auto;
        position: relative;
        top: auto;
        left: auto;
        margin-top: 35.46px;
        padding-left: 20px;
    `}
`;

const LandingContactUsPopupTitleStyle = styled.div`
    position: absolute;
    top: 64px;
    // top: 30px;
    left: 24px;
    height: 18px;
    width: 152px;
    color: #0A1F44;
    font-family: Inter-Regular;
    font-size: 14px;
    line-height: 18px;
    z-index: 3;
    ${mdDownN`
        width: auto;
        position: relative;
        top: auto;
        left: auto;
        margin-top: 20px;
        padding-left: 20px;
    `}
`;

const LandingContactUsPopupPhoneStyle = styled.div`
    position: absolute;
    // top: 64px;
    top: 92px;
    left: 24px;
    height: 18px;
    width: 153px;
    &.mla{
        width: auto;;
    }
    color: #0A1F44;
    font-family: Inter-Regular;
    font-size: 14px;
    line-height: 18px;
    z-index: 3;
    ${mdDownN`
        position: relative;
        top: auto;
        left: auto;
        margin-top: 16px;
        padding-left: 20px;
    `}
`;

const LandingContactUsPopupEmailStyle = styled.div`
    position: absolute;
    top: 120px;
    &.mla{
        top: 142px;    
    }
    // top: 98px;
    left: 24px;
    height: 18px;
    width: 150px;
    color: #0A1F44;
    font-family: Inter-Regular;
    font-size: 14px;
    line-height: 18px;
    z-index: 3;
    ${mdDownN`
        position: relative;
        top: auto;
        left: auto;
        margin-top: 16px;
        padding-left: 20px;
    `}
`;

const LandingDrawerGroupStyle = styled.div`
    display:none;
    ${mdDownN`
        position:absolute;
        left:0px;
        // background: green;
        display: flex;
        width:59px;
        border-right: 1px solid #596780;
        height:60px;
        color: white;
        align-items: center;
        cursor: pointer;
    `}
`;
const LandingDrawerStyle = styled.div`
    display:none;
    ${mdDownN`
        position: absolute;
        display:block;
        height: calc(100vh - 60px);
        box-shadow: 6px 6px 20px 0 rgba(20,40,75,0.16);
        width: ${props=>props.drawer?'300':'0'}px;
        opacity: ${props=>props.drawer?'1':'0'};
        overflow: hidden;
        transition-duration: 0.3s;
        background: white;
        top:60px;
        left:0;


    `}
`;
const LandingDrawerRowItemGroupStyle = styled.div`
    display:none;
    ${mdDownN`
        position: relative;
        display:flex;
        height: auto;
        // margin-top:60px;
        width: 100%;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        
    `}
`;

const LandingDrawerBtnStyle = styled.div`
    width: 14px;
    height:13px;
    position: relative;
    margin: auto;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
    span{
        margin:0px;
        padding: 0px;
        display: block;
        position: absolute;
        height: 2px;
        width: 100%;
        background: white;
        border-radius: 10px;
        opacity: 1;
        left: 0;
        
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: .25s ease-in-out;
        -moz-transition: .25s ease-in-out;
        -o-transition: .25s ease-in-out;
        transition: .25s ease-in-out;
    }
    
    span:nth-child(1){
        top:${props=>props.drawer?'5':'-0.5'}px;
        width: ${props=>props.drawer?'0':'100'}%;
        left: ${props=>props.drawer?'50%':'0px'};
        
    }
    span:nth-child(2),span:nth-child(3){top:5px;}
    span:nth-child(4){
        top:${props=>props.drawer?'5':'10.5'}px;
        width: ${props=>props.drawer?'0':'100'}%;
        left: ${props=>props.drawer?'50%':'0px'};
    }
    span:nth-child(2){
        -webkit-transform: rotate(${props=>props.drawer?'45':'0'}deg);
        -moz-transform: rotate(${props=>props.drawer?'45':'0'}deg);
        -o-transform: rotate(${props=>props.drawer?'45':'0'}deg);
        transform: rotate(${props=>props.drawer?'45':'0'}deg);
    }
    span:nth-child(3){
        -webkit-transform: rotate(${props=>props.drawer?'-45':'0'}deg);
        -moz-transform: rotate(${props=>props.drawer?'-45':'0'}deg);
        -o-transform: rotate(${props=>props.drawer?'-45':'0'}deg);
        transform: rotate(${props=>props.drawer?'-45':'0'}deg);
    }
    
`;
const LandingDrawerColumnItemGroupStyle = styled.div`
    display:none;
    ${mdDownN`
        position: relative;
        display:flex;
        height: auto;
        // margin-top:60px;
        width: 100%;
        flex-direction: column;
        justify-content: flex-start;
        // align-items: center;
        padding-top: 24px;

        
    `}
`;

const LandingDrawerItemHorLineStyle=styled.div`
    display:none;
    ${mdDownN`
        display:block;
        box-sizing: border-box;
        height: 2px;
        width: 291px;
        border: 1px solid #E1E4E8;
    `}
`;

const LandingDrawerItemTitleStyle = styled.div`
    display:none;
    ${mdDownN`
        display inline-block;
        color: #0A1F44;
        font-family: Inter;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 27px;
        padding-left: 20px;
    `}
`;

const getContact = site =>{
    let result = null
    switch (site){
        case 'bm':
            result = {
                name: 'Brian Mae Pte Ltd.',
                email: 'SME@brianmae.com',
                phone: '+65 6224 6633'
            }
            break

        case 'mla':
            result = {
                name: 'Multi-Lines Agencies',
                email: 'info@multilines.com.sg',
                phone: <span>+ 65   9820 4276 / 8499 0385 / 9171 1477</span>
            }
            break
        case 'gnm':
        default:
            result = {
                name: 'g&m Pte Ltd.',
                email: 'corporate@gnm.com.sg',
                phone: '+65 6576 9855'
            }
    }
    return result
}


const LandingHeader = (props) => {
    const [showContact, setShowContact] = useState(false);
    const [timeDiff, setTimeDiff] = useState(new Date());
    const elemRef = useRef(null);
    const drawerElemRef = useRef(null);
    const menuElemRef = useRef(null);
    const contact = getContact(props.site)
    const selectContact = () => {
        console.log("selectContact clicked");
        setShowContact(!showContact);
        _gaPushEvent('contactus');
        _gaPushData({
            'event': 'vpageview',
            'pageStep': 'View-Contact-agent',
            'vPath': '/viewcontactagent',
        });
    }

    const selectPath = () => {
        console.log("href = "+window.location.href);
        window.open(window.location.href + '#path','Relax','height=520,width=500');
    }

    const qbeLogoClick = (event) => {
        console.log("href = " + process.env.REACT_APP_QBE_SITE_URL);
        window.open(process.env.REACT_APP_QBE_SITE_URL);
    }

    const gnmLogoClick = (event) => {
        console.log("href = "+ process.env.REACT_APP_GNM_SITE_URL);
        window.open(process.env.REACT_APP_GNM_SITE_URL);
    }
    const [showDrawer, setShowDrawer] = useState(false);

    const selectDrawer = (e) => {

        console.log("selectDrawer clicked: ",e.type);
        if(new Date()-timeDiff>150){
            setShowDrawer(prevState => {
                return !prevState;
            });
        }
    }
    useEffect(()=>{
        function handleDrawerClickOutside(event){

            if(drawerElemRef.current && !drawerElemRef.current.contains(event.target)){
                setTimeDiff(new Date())
                console.log('drawer outside clicked: ',event.type)
                event.cancelBubble = true
                setShowDrawer(false);
            }
        }
        //
        if(showDrawer){
            document.addEventListener("mousedown", handleDrawerClickOutside);
            document.addEventListener("scroll", handleDrawerClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleDrawerClickOutside);
            document.removeEventListener("scroll", handleDrawerClickOutside);
        }
    },[showDrawer])
    useEffect(() => {
        function handleClickOutside(event){
            if(elemRef.current && !elemRef.current.contains(event.target)){
                setShowContact(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);
    const getLogoGroup = site =>{
        let result = null
        switch (site){
            case 'bm':
                result =
                <LandingLogoGroup2Style>
                    <LandingBmLogoStyle src={BMLogo}/>
                    <LandingPathStyle onClick={selectPath}/>
                    <LandingQbeLogoStyle onClick={qbeLogoClick}/>
                </LandingLogoGroup2Style>
                break
            case 'mla':
                result =
                <LandingLogoGroup2Style>
                    <LandingMLALogoStyle src={MLALogo}/>
                    <LandingPathStyle left={'left: 42px;'} onClick={selectPath}/>
                    <LandingQbeLogoStyle  left={'left: 50px;'}  onClick={qbeLogoClick}/>
                </LandingLogoGroup2Style>
                break
            case 'gnm':
            default:
                result =
                <LandingLogoGroup2Style>
                    <LandingGnmLogoStyle src={GNMLogo} onClick={gnmLogoClick}/>
                    <LandingPathStyle onClick={selectPath}/>
                    <LandingQbeLogoStyle onClick={qbeLogoClick}/>
                </LandingLogoGroup2Style>

        }
        return result
    }
    const getAgentText = site =>{
        let result = null
        switch (site){
            case 'bm':
                result =<LandingContactUsPopupYourAgentStyle>Your Insurance Broker</LandingContactUsPopupYourAgentStyle>
                break
            case 'mla':
                result = <LandingContactUsPopupYourAgentStyle>Your Insurance Agency</LandingContactUsPopupYourAgentStyle>
                break
            case 'gnm':
            default:
                result =<LandingContactUsPopupYourAgentStyle>Your Insurance Broker</LandingContactUsPopupYourAgentStyle>

        }
        return result
    }
    return (
        <LandingHeaderStyle id="header">
            <LandingDrawerGroupStyle onClick={selectDrawer} ref={menuElemRef}>
                <LandingDrawerBtnStyle drawer={showDrawer}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </LandingDrawerBtnStyle>
            </LandingDrawerGroupStyle>
            <LandingLogoGroup1Style id="logo">
                {
                    getLogoGroup(props.site)
                }
            </LandingLogoGroup1Style>
            <LandingContactUsGroupStyle>
                <LandingContactUsStyle onClick={selectContact}>
                    Contact us
                </LandingContactUsStyle>
                { showContact &&
                <React.Fragment>
                    <LandingContactUsUnderlineStyle/>
                    <LandingContactUsPopupStyle onClick={selectContact} ref={elemRef}>
                        {
                            getAgentText(props.site)
                        }

                        {
                            <React.Fragment>
                                <LandingContactUsPopupTitleStyle>
                                    {contact.name}
                                </LandingContactUsPopupTitleStyle>
                                < LandingContactUsPopupPhoneStyle >
                                    {contact.phone}
                                </LandingContactUsPopupPhoneStyle>
                                <LandingContactUsPopupEmailStyle className={props.site==='mla'?' mla ':''}>
                                    {contact.email}
                                </LandingContactUsPopupEmailStyle>
                            </React.Fragment>
                        }
                        <LandingContactUsPopupBorderStyle className={props.site==='mla'?' mla ':''}/>

                    </LandingContactUsPopupStyle>
                </React.Fragment>
                }
            </LandingContactUsGroupStyle>
            <LandingDrawerStyle drawer={showDrawer} ref={drawerElemRef}>
                {/*<LandingDrawerRowItemGroupStyle>*/}
                {/*    <LandingContactUsIconGroupStyle>*/}
                {/*        <LandingContactUsIconStyle src={ContactUsIcon}/>*/}
                {/*    </LandingContactUsIconGroupStyle>*/}
                {/*    <LandingDrawerItemTitleStyle>Login</LandingDrawerItemTitleStyle>*/}
                {/*</LandingDrawerRowItemGroupStyle>*/}

                <LandingDrawerColumnItemGroupStyle>
                    <LandingDrawerItemTitleStyle>Contact us</LandingDrawerItemTitleStyle>
                    <LandingDrawerItemHorLineStyle/>
                    {
                        getAgentText(props.site)
                    }

                    {
                        <React.Fragment>
                            <LandingContactUsPopupTitleStyle>
                                {contact.name}
                            </LandingContactUsPopupTitleStyle>
                            < LandingContactUsPopupPhoneStyle className={props.site==='mla'?'mla':''}>
                                {contact.phone}
                            </LandingContactUsPopupPhoneStyle>
                            <LandingContactUsPopupEmailStyle>
                                {contact.email}
                            </LandingContactUsPopupEmailStyle>
                        </React.Fragment>
                    }
                </LandingDrawerColumnItemGroupStyle>
            </LandingDrawerStyle>
        </LandingHeaderStyle>
    );
}

export default withRouter(LandingHeader);
